const BLOB_STORAGE_DOMAIN = '0edx89zhjrasqnjf.public.blob.vercel-storage.com'
const CDN_DOMAIN = 'cdn.brew.new'

export function toCdnUrl(url: string): string {
  if (!url) {
    return url
  }
  return url.replace(BLOB_STORAGE_DOMAIN, CDN_DOMAIN)
}
